import { newHttpBatchRpcSession, RpcPromise } from 'capnweb';
import { getDashboardApiPath } from './appSlug'

export function api() {
  return newHttpBatchRpcSession(getDashboardApiPath())
}
